import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Share2 } from 'react-feather';
import { useAtomValue } from 'jotai';
import toast from 'react-hot-toast';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { historyAtom } from '../../history';

export const ShareButton = (props: {
  backgroundColor?: ouiStyle.InStyleWithMediaQueries['backgroundColor'],
  color?: ouiStyle.InStyleWithMediaQueries['color'],
  borderColor?: ouiStyle.InStyleWithMediaQueries['borderColor'],
  hoverBackgroundColor?: ouiStyle.InStyleWithMediaQueries['backgroundColor'],
  borderRadius?: ouiStyle.InStyleWithMediaQueries['borderRadius'],
  paddingHorizontal?: ouiStyle.InStyleWithMediaQueries['paddingHorizontal'],
  paddingVertical?: ouiStyle.InStyleWithMediaQueries['paddingVertical'],
  cursor?: ouiStyle.InStyleWithMediaQueries['cursor'],
  size?: string | number,
}) => {
  const {
    backgroundColor,
    color,
    borderColor,
    hoverBackgroundColor,
    borderRadius,
    paddingHorizontal,
    paddingVertical,
    cursor,
    size,
  } = props;
  const location = useAtomValue(historyAtom);
  const {
    _,
  } = useLingui();
  const onClick = React.useCallback(async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: document.title,
          url: window.location.href,
        });
      } else {
        await navigator.clipboard.writeText(window.location.href);
        toast.success(_(msg`Le lien a été copié vers votre presse papier`));
      }
    } catch (err) {
      if (!(err instanceof DOMException && err.name === 'AbortError')) {
        toast.error(_(msg`Votre navigateur ne permet pas le partage, veuillez partager le lien manuellement`));
      }
    }
  }, [location, _]);
  return (
    <ouiDom.Button.Button
      type="button"
      onClick={onClick}
      backgroundColor={backgroundColor}
      color={color}
      borderColor={borderColor}
      hoverBackgroundColor={hoverBackgroundColor}
      borderRadius={borderRadius}
      iconContainer
      paddingHorizontal={paddingHorizontal}
      paddingVertical={paddingVertical}
      title={_(msg`Partager`)}
      cursor={cursor}
    >
      <Share2 size={size} />
    </ouiDom.Button.Button>
  );
};
